var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-old",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21l-1 -4l-2 -3v-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14l-1 -3l4 -3l3 2l3 .5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17l-2 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOld);
export default __webpack_public_path__ + "static/media/old.36b8b39fcf2ed05f89d01c703a147e75.svg";
export { ForwardRef as ReactComponent };